import React, { Component } from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Spin, Icon } from "antd";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin/>;

class AuthRoute extends Component{
	constructor(props) {
		super(props);
		this.state = {
			isLoading: props.isLoading
		};
	}
	
	componentWillReceiveProps(nextProps) {
		const { isLoading } = nextProps;
		this.setState({
			isLoading
		});
		
	}
	
	render() {
		const { component: Component, auth, ...rest } = this.props;
		const { isLoading } = this.state;
		return (
			<Route {...rest} render={props => {
				if (auth) {
					return isLoading ? <Row type='flex' justify='center' align='middle' className='Spin'>
						<Spin indicator={antIcon}/>
					</Row> : <Component {...props}/>;
				} else if (isLoading) {
					return <Row type='flex' justify='center' align='middle' className='Spin'>
						<Spin indicator={antIcon}/>
					</Row>;
				}
				return <Redirect to={{
					pathname: "/login"
				}}/>;
			}
			}/>
		);
	}
}

const mapStateToProps = ({ user: { auth, isLoading } }) => {
	return {
		auth,
		isLoading
	};
};

export default connect(mapStateToProps)(AuthRoute);




// WEBPACK FOOTER //
// ./src/components/AuthRoute/AuthRoute.js